import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputErrors } from '../errors';
import { TextInputComponent } from '../text-input/text-input.component';

/**
 * The Nomidio Phone Input Component presents an internationalised text input field to the user.
 *
 * Validation is built in, if the value is an invalid phone number the control will have the 'phone' error.
 *
 * The control you provide to this component will have its value set to a {@link PhoneInputValue} instance.
 *
 * * You can get the number with {@link PhoneInputValue.e164Number}.
 * * Set the number by changing the control's value.
 *
 *
 * @example // Setup
 * // ts
 * constructor(
 * ) {
 *   this.form = new FormGroup({
 *     'phone': new FormControl(),
 *   });
 * }
 * // html
 * <app-phone-input [control]="phone"></app-phone-input>
 *
 * @example // Get the phone number
 * const phoneNumber = phone.value?.e164Number;
 *
 * @example // Set the phone number
 * phone.setValue('+447498765432');
 */
@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PhoneInputComponent extends TextInputComponent {
  @Input()
  public override control!: FormControl;

  /**
   * A list of countries to prefer in the dropdown.
   *
   * @see https://github.com/jackocnr/intl-tel-input preferredCountries
   */
  @Input()
  public preferredCountries: string[] = ['gb', 'us'];

  @Input()
  public override errors: InputErrors = {
    'required': 'This field is required',
    'phone': 'This must be a valid phone number',
  };
}
